import { oauthService } from '@virginmoney/api-connector-lib';

export const fetchJWT = async (
  apiBaseUrlPaas,
  bankId,
  body,
  accessToken,
  userTrackingId
) => {
  try {
    const responseShortTermTokenJson = await fetchShortTermToken(
      apiBaseUrlPaas,
      bankId,
      body,
      accessToken,
      userTrackingId
    );
    const shortTermAccessToken = await responseShortTermTokenJson[
      'access_token'
    ];
    const jwtToken = await fetchExchangeToken(
      apiBaseUrlPaas,
      bankId,
      body,
      shortTermAccessToken,
      userTrackingId
    );
    return jwtToken;
  } catch (error) {
    throw error;
  }
};

export const fetchShortTermToken = async (
  apiBaseUrlPaas,
  bankId,
  body,
  accessToken,
  userTrackingId
) => {
  const response = await oauthService.shortTermAccessToken(
    apiBaseUrlPaas,
    bankId,
    body,
    accessToken,
    userTrackingId
  );

  if (response.error) throw new Error(response.error);
  return response;
};

export const fetchExchangeToken = async (
  apiBaseUrlPaas,
  bankId,
  body,
  shortAccessToken,
  userTrackingId
) => {
  const response = await oauthService.exchangeOAuthJWTToken(
    apiBaseUrlPaas,
    bankId,
    body,
    shortAccessToken,
    userTrackingId
  );

  if (response.error) throw new Error(response.error);
  return response;
};
